// Access token da sessão, guardado só em memória (L-21).
//
// Nunca vai para localStorage/sessionStorage: um script injetado na página não
// consegue lê-lo depois de um reload. O refresh token nem passa pelo SPA: fica no
// cookie HttpOnly gabriela_refresh, gravado pelo servidor e enviado só para /api/auth/.
// Cada aba tem o seu access token e o renova pelo cookie compartilhado.

let accessToken = null;

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
    accessToken = token || null;
};

export const clearAccessToken = () => {
    accessToken = null;
};
